var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"homeVideoEmpty"},[_c('div',{staticClass:"homeVideoEmpty_message"},[_c('span',[_vm._v(" 現在、閲覧できるカメラがありません。 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }